import { render, staticRenderFns } from "./ErrorInternet.vue?vue&type=template&id=3796d435&scoped=true"
import script from "./ErrorInternet.vue?vue&type=script&lang=js"
export * from "./ErrorInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796d435",
  null
  
)

export default component.exports